/* ============================================================
   Joykek — Boyut özel düzeltmeleri (JS)
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     ÜRÜN KARTI — kartın neresine tıklanırsa tıklansın ürün sayfası
     ----------------------------------------------------------
     Neden delegasyon: kartlar birçok yerde ve bir kısmı AJAX ile
     sonradan geliyor (filtre uygulama, daha fazla yükle, son
     görüntülenenler). Tek tek bağlamak yerine document seviyesinde
     dinlenirse sonradan eklenen kartlar da kapsanır.

     Gerçek etkileşim öğeleri (link, buton, form alanı, favori,
     karşılaştır) kendi işlerini yapar; onlara dokunulmaz.
  ---------------------------------------------------------- */
  var INTERACTIVE = 'a, button, input, select, textarea, label, summary, ' +
    '[role="button"], ap-wishlistbutton, ap-comparebutton, ap-quantityselector';

  var CARD = '.product-item-bg_wrapper, .product-item';

  document.addEventListener('click', function (e) {
    // Sağ tık / orta tık bu dinleyiciye düşmez, yine de güvence
    if (e.button !== 0) return;

    // Kendi işi olan bir öğeye tıklandıysa karışma
    if (e.target.closest && e.target.closest(INTERACTIVE)) return;

    var card = e.target.closest && e.target.closest(CARD);
    if (!card) return;

    var link = card.querySelector('a[href*="/products/"]');
    if (!link || !link.getAttribute('href')) return;

    // Ctrl/Cmd + tık yeni sekmede açsın (tarayıcı alışkanlığı korunur)
    if (e.metaKey || e.ctrlKey || e.shiftKey) {
      window.open(link.href, '_blank', 'noopener');
      return;
    }

    window.location.href = link.href;
  });
})();

/* ============================================================
   KOLEKSIYON — ustte yapiskan filtre seridi
   ------------------------------------------------------------
   Tema "collection-top" modunda .open sinifini ekliyor ama
   karsiligi olan CSS'i yazmamis. Serit/panel davranisi burada.

   Delegasyon kullaniliyor cunku filtre uygulaninca tema
   #ap-facetfilters icerigini AJAX ile komple degistiriyor —
   dogrudan baglanan dinleyiciler o an olurdu.
   ============================================================ */
(function () {
  'use strict';

  function aside() {
    return document.querySelector('.collection-top .ap-productfacet__aside');
  }

  /* ---- Serit tiklamasi paneli acar/kapatir ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var header = e.target.closest('.collection-top .drawer__header');
    if (!header) return;

    // Serit icindeki gercek baglantilar (Temizle, aktif filtre etiketleri)
    // kendi islerini yapsin, panel toggle olmasin
    if (e.target.closest('a, button:not(.drawer__close-button)')) return;

    var el = aside();
    if (el) el.classList.toggle('open');
  });

  /* ---- Yapiskan seridin ust ofseti ----
     Temanin CSS calc() formulu kullanilamiyor (tanimsiz degisken tum
     bildirimi gecersiz kiliyor). Header yapiskan degilse kucuk bir
     bosluk yeter; yapiskansa yuksekligi kadar asagi itiyoruz. */
  /* Sabitlenmis ust seridin (header) alt kenarini olcup CSS degiskenine yazar.
     Basligi sinifina gore aramak yaniltiyor: kaydirmadan once position:static,
     kaydirinca sabitlenen baska bir eleman devreye giriyor. Bunun yerine
     ekranin TEPESINDE gercekte ne duruyorsa o olculuyor.
     Hem koleksiyon filtre seridi hem urun sayfasi gorsel sutunu bunu kullanir. */
  function measureStickyTop() {
    var offset = 12;
    try {
      var stack = document.elementsFromPoint(Math.round(window.innerWidth / 2), 4) || [];
      for (var i = 0; i < stack.length; i++) {
        var n = stack[i];
        var pos = window.getComputedStyle(n).position;
        if (pos === 'fixed' || pos === 'sticky') {
          var bottom = Math.round(n.getBoundingClientRect().bottom);
          // Kendisi yapisan hedeflerimizi hesaba katma (geri besleme olur)
          if (n.closest && n.closest('.ap-productfacet__aside, .product__media')) continue;
          if (bottom + 10 > offset) offset = bottom + 10;
        }
      }
    } catch (e) { /* elementsFromPoint yoksa yedek deger kalir */ }
    document.documentElement.style.setProperty('--jk-sticky-top', offset + 'px');
    return offset;
  }

  function setFilterTop() {
    var el = aside();
    if (!el) return;
    el.style.setProperty('--jk-filter-top', measureStickyTop() + 'px');
  }

  /* ---- Yapisma durumu (golge icin) ---- */
  function trackStuck() {
    var el = aside();
    if (!el) return;
    var ticking = false;
    function update() {
      ticking = false;
      // Sticky yapistiginda elemanin ust kenari, CSS'teki `top` degerine
      // kilitlenir. Once o degeri okuyup karsilastiriyoruz.
      var stickyTop = parseFloat(window.getComputedStyle(el).top) || 0;
      // Yapistiginda ust kenar tam olarak stickyTop'a kilitlenir.
      // "<=" kullanilirsa serit yukari kayip ekrandan ciktiginda da
      // true doner (yanlis pozitif) — bu yuzden esitlik toleransi.
      var d = el.getBoundingClientRect().top - stickyTop;
      el.classList.toggle('is-stuck', d > -2 && d < 2);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { setFilterTop(); update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---- Aktif filtre sayaci bos mu? ----
     CSS :empty bosluk karakteri yuzunden ise yaramiyor; sinifi burada veriyoruz. */
  function syncCount() {
    var title = document.querySelector('.collection-top .drawer__title');
    if (!title) return;
    var badge = title.querySelector('.ap-productfacet__active-count');
    var has = !!(badge && badge.textContent && badge.textContent.trim() !== '');
    title.classList.toggle('jk-has-count', has);
  }

  /* ---- Icinde bulunulan kategoriyi isaretle ---- */
  function markCurrentCategory() {
    var here = window.location.pathname.replace(/\/$/, '');
    var links = document.querySelectorAll(
      '.collection-top .ap-productfacet_aside__categories-list a'
    );
    Array.prototype.forEach.call(links, function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      a.classList.toggle('jk-current', href !== '' && href === here);
    });
  }

  function init() {
    // Olcum her sayfada gerekli (urun sayfasi gorsel sutunu da kullaniyor)
    measureStickyTop();
    var onWinScroll = function () { window.requestAnimationFrame(measureStickyTop); };
    window.addEventListener('scroll', onWinScroll, { passive: true });
    window.addEventListener('resize', onWinScroll, { passive: true });

    if (!document.querySelector('.collection-top')) return;
    setFilterTop();
    trackStuck();
    markCurrentCategory();
    syncCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Filtre AJAX'i panel icerigini yeniden yazinca kategori isaretini tazele
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.collection-top #ap-facetfilters-form')) {
      window.setTimeout(function () { markCurrentCategory(); syncCount(); }, 600);
    }
  });
})();

/* ============================================================
   BUNDLEME seçici kartlarına kitap detayı   (JK 2026-09-28)
   Kartta ürün sayfası bağlantısı yoktu; müşteri seçeceği
   kitabın ne olduğunu göremiyordu. "Kitabı incele" bağlantısı
   sayfa içinde bir ürün kartı açar (yeni sekme yok, seçim
   kaybolmaz). Kart içinde tam açıklama + ürün sayfası linki.
   ============================================================ */
(function () {
  'use strict';
  var KOLEKSIYONLAR = ['tum-koleksiyon-kitaplar', 'kitaplik'];
  var harita = null, sozVerilen = null, kutu = null, sonOdak = null;

  function anahtar(s) {
    return (s || '').toString().normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function metneCevir(html) {
    // blok etiketleri bosluga cevrilmezse cumleler birbirine yapisiyor
    var ham = (html || '')
      .replace(/<\/(p|div|h[1-6]|li|tr|blockquote|section)>/gi, ' ')
      .replace(/<br\s*\/?>/gi, ' ');
    var d = document.createElement('div');
    d.innerHTML = ham;
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function basligiAyikla(metin, baslik) {
    // bircok urunde aciklama, urun basligiyla basliyor - tekrari at
    var m = (metin || '').trim(), b = (baslik || '').trim();
    if (b && m.toLowerCase().indexOf(b.toLowerCase()) === 0) {
      m = m.slice(b.length).replace(/^[\s.,:;-]+/, '').trim();
    }
    return m;
  }

  function haritayiKur() {
    if (sozVerilen) return sozVerilen;
    sozVerilen = Promise.all(KOLEKSIYONLAR.map(function (h) {
      return fetch('/collections/' + h + '/products.json?limit=250')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    })).then(function (sonuclar) {
      harita = {};
      sonuclar.forEach(function (d) {
        (d.products || []).forEach(function (p) {
          harita[anahtar(p.title)] = {
            handle: p.handle,
            baslik: p.title,
            aciklama: basligiAyikla(metneCevir(p.body_html), p.title),
            gorsel: (p.images && p.images[0] && p.images[0].src) || ''
          };
        });
      });
      return harita;
    }).catch(function () { return null; });
    return sozVerilen;
  }

  function kutuyuKur() {
    if (kutu) return kutu;
    kutu = document.createElement('div');
    kutu.className = 'jk-kitap-katman';
    kutu.setAttribute('hidden', '');
    kutu.innerHTML =
      '<div class="jk-kitap-perde" data-kapat></div>' +
      '<div class="jk-kitap-kutu" role="dialog" aria-modal="true" aria-labelledby="jk-kitap-baslik">' +
        '<button type="button" class="jk-kitap-kapat" data-kapat aria-label="Kapat">&times;</button>' +
        '<div class="jk-kitap-ic">' +
          '<div class="jk-kitap-gorsel"><img alt="" /></div>' +
          '<div class="jk-kitap-bilgi">' +
            '<h3 id="jk-kitap-baslik"></h3>' +
            '<div class="jk-kitap-fiyat"></div>' +
            '<div class="jk-kitap-metin"></div>' +
            '<a class="jk-kitap-sayfa" href="#">Ürün sayfasını aç</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(kutu);
    kutu.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-kapat')) kapat();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !kutu.hasAttribute('hidden')) kapat();
    });
    return kutu;
  }

  /* ---- fareyle uzerine gelince kucuk onizleme karti ---- */
  var onizleme = null, onizlemeZaman = null;
  var fareVar = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function onizlemeKur() {
    if (onizleme) return onizleme;
    onizleme = document.createElement('div');
    onizleme.className = 'jk-kitap-onizleme';
    onizleme.setAttribute('hidden', '');
    onizleme.innerHTML =
      '<div class="jk-onizleme-gorsel"><img alt="" /></div>' +
      '<div class="jk-onizleme-bilgi">' +
        '<div class="jk-onizleme-baslik"></div>' +
        '<div class="jk-onizleme-metin"></div>' +
        '<button type="button" class="jk-onizleme-buton">Kitap detayları</button>' +
      '</div>';
    document.body.appendChild(onizleme);

    // kartin uzerine gelinince kapanmasin, ayrilinca kapansin
    onizleme.addEventListener('mouseenter', function () { window.clearTimeout(onizlemeZaman); });
    onizleme.addEventListener('mouseleave', onizlemeGizle);
    return onizleme;
  }

  function onizlemeGizle() {
    window.clearTimeout(onizlemeZaman);
    onizlemeZaman = window.setTimeout(function () {
      if (onizleme) onizleme.setAttribute('hidden', '');
    }, 220);
  }

  function onizlemeHemenGizle() {
    window.clearTimeout(onizlemeZaman);
    if (onizleme) onizleme.setAttribute('hidden', '');
  }

  function onizlemeGoster(kart, kayit) {
    if (kutu && !kutu.hasAttribute('hidden')) return;   // buyuk kart acikken cikma
    var o = onizlemeKur();
    var img = o.querySelector('.jk-onizleme-gorsel img');
    if (kayit.gorsel) { img.src = kayit.gorsel; img.parentNode.removeAttribute('hidden'); }
    else { img.parentNode.setAttribute('hidden', ''); }
    o.querySelector('.jk-onizleme-baslik').textContent = kayit.baslik;
    var ozet = kayit.aciklama || '';
    o.querySelector('.jk-onizleme-metin').textContent =
      ozet.length > 190 ? ozet.slice(0, 190).replace(/\s+\S*$/, '') + '…' : ozet;

    var btn = o.querySelector('.jk-onizleme-buton');
    btn.onclick = function (e) {
      e.preventDefault(); e.stopPropagation();
      onizlemeHemenGizle();
      sonOdak = btn;
      var f = kart.querySelector('.bundleme-card-price');
      ac(kayit, f ? f.textContent.trim() : '');
    };
    o.removeAttribute('hidden');

    // konumlandir: kartin sagina, sigmazsa soluna; dikeyde ekran icinde tut
    var k = kart.getBoundingClientRect();
    var g = o.getBoundingClientRect();
    var bosluk = 12;
    var sol = k.right + bosluk;
    if (sol + g.width > window.innerWidth - 8) sol = k.left - g.width - bosluk;
    if (sol < 8) sol = 8;
    var ust = k.top + (k.height - g.height) / 2;
    if (ust < 8) ust = 8;
    if (ust + g.height > window.innerHeight - 8) ust = window.innerHeight - g.height - 8;
    o.style.left = Math.round(sol) + 'px';
    o.style.top = Math.round(ust) + 'px';
  }

  function kapat() {
    if (!kutu) return;
    kutu.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    if (sonOdak && sonOdak.focus) sonOdak.focus();
  }

  function ac(kayit, fiyat) {
    var k = kutuyuKur();
    var img = k.querySelector('.jk-kitap-gorsel img');
    if (kayit.gorsel) { img.src = kayit.gorsel; img.alt = kayit.baslik; img.parentNode.removeAttribute('hidden'); }
    else { img.removeAttribute('src'); img.parentNode.setAttribute('hidden', ''); }
    k.querySelector('#jk-kitap-baslik').textContent = kayit.baslik;
    k.querySelector('.jk-kitap-fiyat').textContent = fiyat || '';
    k.querySelector('.jk-kitap-metin').textContent = kayit.aciklama || 'Bu kitap için açıklama girilmemiş.';
    k.querySelector('.jk-kitap-sayfa').setAttribute('href', '/products/' + kayit.handle);
    k.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    var kapatBtn = k.querySelector('.jk-kitap-kapat');
    if (kapatBtn.focus) kapatBtn.focus();
  }

  function kartlariZenginlestir() {
    if (!document.querySelector('.bundleme-card:not([data-jk-detay])')) return;
    haritayiKur().then(function (h) {
      if (!h) return;
      var kartlar = document.querySelectorAll('.bundleme-card:not([data-jk-detay])');
      Array.prototype.forEach.call(kartlar, function (kart) {
        kart.setAttribute('data-jk-detay', '1');
        var bas = kart.querySelector('.bundleme-card-title');
        if (!bas) return;
        var kayit = h[anahtar(bas.textContent)];
        if (!kayit) return;

        var govde = kart.querySelector('.bundleme-card-body') || kart;
        if (govde.querySelector('.jk-kitap-detay')) return;
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'jk-kitap-detay';
        d.textContent = 'Kitabı incele';
        d.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          onizlemeGizle();
          sonOdak = d;
          var f = kart.querySelector('.bundleme-card-price');
          ac(kayit, f ? f.textContent.trim() : '');
        });
        d.addEventListener('keydown', function (e) { e.stopPropagation(); });
        govde.appendChild(d);

        if (fareVar) {
          kart.addEventListener('mouseenter', function () {
            window.clearTimeout(onizlemeZaman);
            onizlemeZaman = window.setTimeout(function () { onizlemeGoster(kart, kayit); }, 320);
          });
          kart.addEventListener('mouseleave', onizlemeGizle);
        }
      });
    });
  }

  function baslat() {
    kartlariZenginlestir();
    var zaman;
    new MutationObserver(function () {
      window.clearTimeout(zaman);
      zaman = window.setTimeout(kartlariZenginlestir, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();

/* ============================================================
   Sepette indirim kodu alanı   (JK 2026-09-28)
   Kod SEPETE UYGULANMAZ; müşterinin girdiği kod oturumda
   tutulur ve ödeme adımına taşınır. Sebep: Shopify'da sepete
   uygulanan kod storefront'tan kaldırılamıyor, bir kez giren
   müşteride kalıcı oluyordu. Bu yolla her ziyarette müşteri
   kodu kendisi girer, tarayıcı kapanınca kod düşer.
   ============================================================ */
(function () {
  'use strict';
  var BEKLEYEN = 'jk_bekleyen_kod';

  function oturumOku(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function oturumYaz(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function oturumSil(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }

  function cerezOku(ad) {
    var parcalar = (document.cookie || '').split(';');
    for (var i = 0; i < parcalar.length; i++) {
      var t = parcalar[i].trim();
      if (t.indexOf(ad + '=') === 0) return t.slice(ad.length + 1);
    }
    return '';
  }

  /* Eski surumden kalan cerez temizlenmezse kod kendiliginden uygulanir */
  function eskiCereziTemizle() {
    if (!cerezOku('discount_code')) return;
    document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }

  var kapsamSozu = null;
  function kapsamiGetir() {
    if (kapsamSozu) return kapsamSozu;
    kapsamSozu = fetch('/collections/tum-koleksiyon-kitaplar/products.json?limit=250',
                       { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return (d.products || []).map(function (u) { return u.handle; }); })
      .catch(function () { return null; });
    return kapsamSozu;
  }

  function kutuOlustur() {
    var d = document.createElement('div');
    d.className = 'jk-kod-kutu';
    d.innerHTML =
      '<div class="jk-kod-baslik">İndirim kodunuz var mı?</div>' +
      '<form class="jk-kod-satir" novalidate>' +
        '<input type="text" class="jk-kod-girdi" placeholder="Kodu buraya yazın" ' +
               'autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="İndirim kodu" />' +
        '<button type="submit" class="jk-kod-buton">Uygula</button>' +
      '</form>' +
      '<div class="jk-kod-durum" role="status" aria-live="polite"></div>';
    return d;
  }

  function durumYaz(kutu, metin, tip) {
    var d = kutu.querySelector('.jk-kod-durum');
    d.textContent = metin || '';
    d.className = 'jk-kod-durum' + (tip ? ' jk-kod-durum--' + tip : '');
  }

  function rozetGoster(kutu, kod) {
    var form = kutu.querySelector('.jk-kod-satir');
    var eski = kutu.querySelector('.jk-kod-rozetler');
    if (eski) eski.parentNode.removeChild(eski);
    if (!kod) { form.style.display = ''; durumYaz(kutu, '', ''); return; }
    var kap = document.createElement('div');
    kap.className = 'jk-kod-rozetler';
    var r = document.createElement('span');
    r.className = 'jk-kod-rozet';
    r.textContent = '✓ ' + kod;
    kap.appendChild(r);
    var kaldir = document.createElement('button');
    kaldir.type = 'button';
    kaldir.className = 'jk-kod-kaldir';
    kaldir.textContent = 'kaldır';
    kaldir.addEventListener('click', function () {
      oturumSil(BEKLEYEN);
      kodAktar();
      rozetGoster(kutu, null);
    });
    kap.appendChild(kaldir);
    kutu.insertBefore(kap, form);
    form.style.display = 'none';
    durumYaz(kutu, 'Kodunuz ödeme adımında uygulanacak.', 'iyi');
  }

  /* Bekleyen kodu sepet formlarina gizli alan olarak yazar;
     Shopify bu alani odeme adimina tasir. */
  function kodAktar() {
    var kod = oturumOku(BEKLEYEN) || '';
    var formlar = document.querySelectorAll('form[action*="/cart"]');
    Array.prototype.forEach.call(formlar, function (f) {
      var alan = f.querySelector('input[name="discount"][data-jk]');
      if (!kod) { if (alan && alan.parentNode) alan.parentNode.removeChild(alan); return; }
      if (!alan) {
        alan = document.createElement('input');
        alan.type = 'hidden';
        alan.name = 'discount';
        alan.setAttribute('data-jk', '1');
        f.appendChild(alan);
      }
      alan.value = kod;
    });
  }

  /* Odemeye gecis aninda kodu cereze yazar. Senkron oldugu icin
     kendi yonlendirmesini yapan butonlarda da (Sepette Fatura
     "Odeme Sayfasina Git") yetisir. Cerez sepete indirim islemez;
     yalnizca odeme adiminda okunur ve sepete donulurse temizlenir. */
  function kodCerezeYaz() {
    var kod = oturumOku(BEKLEYEN);
    if (!kod) return;
    document.cookie = 'discount_code=' + encodeURIComponent(kod) + '; path=/';
  }

  function tiklamaYakala() {
    if (document.documentElement.hasAttribute('data-jk-kod-tik')) return;
    document.documentElement.setAttribute('data-jk-kod-tik', '1');

    document.addEventListener('click', function (e) {
      var kod = oturumOku(BEKLEYEN);
      if (!kod) return;
      var t = e.target && e.target.closest
        ? e.target.closest('button, a, input[type="submit"]')
        : null;
      if (!t || t.closest('.jk-kod-kutu')) return;

      // sinif adlarina bagimli kalmadan "odemeye gecis" tespiti
      var metin = (t.textContent || t.value || '').toLowerCase();
      var kimlik = ((t.className || '') + ' ' + (t.id || '')).toLowerCase();
      var adres = t.tagName === 'A' ? (t.getAttribute('href') || '') : '';
      var odemeMi =
        metin.indexOf('ödeme sayfas') !== -1 ||
        metin.indexOf('siparişi tamamla') !== -1 ||
        metin.indexOf('checkout') !== -1 ||
        kimlik.indexOf('checkout') !== -1 ||
        kimlik.indexOf('sf-submit') !== -1 ||
        t.getAttribute('name') === 'checkout' ||
        adres.indexOf('/checkout') !== -1;
      if (!odemeMi) return;

      kodCerezeYaz();
      if (adres && adres.indexOf('/checkout') !== -1 && adres.indexOf('discount=') === -1) {
        t.setAttribute('href', adres + (adres.indexOf('?') === -1 ? '?' : '&') +
          'discount=' + encodeURIComponent(kod));
      }
    }, true);

    document.addEventListener('submit', function (e) {
      if (!oturumOku(BEKLEYEN)) return;
      var f = e.target;
      if (f && f.matches && f.matches('form[action*="/cart"]')) kodCerezeYaz();
    }, true);
  }

  function kodKaydet(kutu, kod) {
    var btn = kutu.querySelector('.jk-kod-buton');
    btn.disabled = true;
    durumYaz(kutu, 'Kontrol ediliyor…', '');
    Promise.all([
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      kapsamiGetir()
    ]).then(function (sonuc) {
      var sepet = sonuc[0], kapsam = sonuc[1];
      btn.disabled = false;
      if (!sepet.items || !sepet.items.length) {
        durumYaz(kutu, 'Sepetiniz boş görünüyor.', 'kotu');
        return;
      }
      var sepettekiler = sepet.items.map(function (i) { return i.handle; });
      var kapsamda = !kapsam || sepettekiler.some(function (h) { return kapsam.indexOf(h) !== -1; });
      if (!kapsamda) {
        durumYaz(kutu, 'Sepetinizdeki ürünler bu indirim kapsamında değil. Özel paketler indirime dahil değildir.', 'kotu');
        return;
      }
      oturumYaz(BEKLEYEN, kod.toUpperCase());
      kodAktar();
      rozetGoster(kutu, kod.toUpperCase());
    }).catch(function () {
      btn.disabled = false;
      durumYaz(kutu, 'Bağlantı hatası, lütfen tekrar deneyin.', 'kotu');
    });
  }

  function yerlestir() {
    var hedefler = [];
    var ozet = document.querySelector('.ccp-summary-row');
    if (ozet && ozet.parentNode) hedefler.push({ kap: ozet.parentNode, once: ozet, ad: 'sepet' });
    var cekmece = document.querySelector('.mini-cart__drawer-footer');
    if (cekmece) hedefler.push({ kap: cekmece, once: cekmece.firstChild, ad: 'cekmece' });

    hedefler.forEach(function (h) {
      if (h.kap.querySelector('.jk-kod-kutu')) return;
      var kutu = kutuOlustur();
      kutu.setAttribute('data-jk-yer', h.ad);
      h.kap.insertBefore(kutu, h.once || null);
      kutu.querySelector('.jk-kod-satir').addEventListener('submit', function (e) {
        e.preventDefault();
        var kod = kutu.querySelector('.jk-kod-girdi').value.trim();
        if (!kod) { durumYaz(kutu, 'Lütfen bir kod yazın.', 'kotu'); return; }
        kodKaydet(kutu, kod);
      });
      rozetGoster(kutu, oturumOku(BEKLEYEN));
    });
    kodAktar();
  }

  function baslat() {
    eskiCereziTemizle();
    tiklamaYakala();
    yerlestir();
    var zaman;
    new MutationObserver(function () {
      window.clearTimeout(zaman);
      zaman = window.setTimeout(yerlestir, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();

/* ============================================================
   Özel Teklif ürünleri - sepette uygulanan indirimi göster
   (JK 2026-09-28)
   İndirim, ürün fiyatına değil otomatik indirim kaydına taşındı
   (bir entegrasyon fiyat alanını eziyordu). Shopify bu indirimi
   ürün sayfasında göstermiyor, yalnızca sepette uyguluyor.
   Oran custom.sepet_indirim_orani alanında; burada okunup
   fiyatın altına ve paket içeriği kutusuna basılır.
   ============================================================ */
(function () {
  'use strict';

  function paraYaz(kurus) {
    var tl = kurus / 100;
    return tl.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function oraniYaz(o) {
    return (Math.round(o * 100) / 100).toString().replace('.', ',');
  }

  function kur() {
    var kap = document.querySelector('[data-jk-indirim-oran]');
    if (!kap || kap.hasAttribute('data-jk-islendi')) return;
    var oran = parseFloat(kap.getAttribute('data-jk-indirim-oran'));
    var fiyat = parseInt(kap.getAttribute('data-jk-fiyat'), 10);   // kuruş
    if (!oran || !fiyat) return;
    kap.setAttribute('data-jk-islendi', '1');

    // tam tutar alanda yazili ise onu kullan; gosterilen ile odenen birebir olsun
    var yazili = parseFloat(kap.getAttribute('data-jk-sepet-fiyat'));
    var indirimli = (yazili && yazili > 0)
      ? Math.round(yazili * 100)
      : Math.round(fiyat * (1 - oran / 100));

    /* Shopify indirimi urunun SATIS fiyati uzerinden uygular; oradaki teknik
       oran musteriye anlamsiz gelir. Musterinin gordugu gercek indirim LISTE
       fiyatina goredir - rozette o gosterilir. */
    var listeTl = parseFloat(kap.getAttribute('data-jk-liste'));
    var liste = (listeTl && listeTl > 0) ? Math.round(listeTl * 100) : 0;
    var gosterilecekOran = oran;
    if (liste && liste > indirimli) {
      gosterilecekOran = (1 - indirimli / liste) * 100;
    }

    /* 1) fiyatın altına sepet fiyatı satırı */
    var fiyatKutusu = document.querySelector('.price, [class*="product__price"], [class*="price__container"]');
    if (fiyatKutusu && !document.querySelector('.jk-sepet-fiyat')) {
      var kutu = document.createElement('div');
      kutu.className = 'jk-sepet-fiyat';
      kutu.innerHTML =
        '<span class="jk-sepet-tutar">' + paraYaz(indirimli) + '</span>' +
        '<span class="jk-sepet-rozet">SEPETTE %' + oraniYaz(gosterilecekOran) + ' İNDİRİM</span>' +
        '<span class="jk-sepet-not">sepete eklediğinizde uygulanır</span>';
      fiyatKutusu.parentNode.insertBefore(kutu, fiyatKutusu.nextSibling);
      /* Ustte urunun indirimsiz fiyati, altta sepette odenecek tutar gorunur.
         (Ustu cizili liste fiyati musteri tarafindan kaldirildi, o yuzden
         sayfada iki fiyat kaliyor: indirimsiz ve indirimli.) */
    }

    /* 2) Paket içeriği kutusu: "Paket Satış Fiyatı" satırındaki tutarı
       indirimli olanla değiştir. Ayrı satır eklemek satırın içine üçüncü
       öğe olarak girip düzeni bozuyordu; tutarı yerinde güncellemek
       "Tek Tek Ürün Toplamı" ile alt alta hizalı kalmasını sağlıyor. */
    var etiket = [].slice.call(document.querySelectorAll('div')).filter(function (e) {
      return e.children.length === 0 && (e.textContent || '').trim() === 'Paket Satış Fiyatı';
    })[0];
    if (etiket && etiket.parentElement) {
      var satir = etiket.parentElement;
      var tutar = [].slice.call(satir.children).filter(function (e) {
        return e !== etiket && /TL/.test(e.textContent || '');
      })[0];
      if (tutar && !tutar.hasAttribute('data-jk-degisti')) {
        tutar.setAttribute('data-jk-degisti', '1');
        tutar.textContent = paraYaz(indirimli);
        tutar.style.color = '#1f6f4a';
        etiket.textContent = 'Paket Satış Fiyatı (%' + oraniYaz(gosterilecekOran) + ' indirimli)';
      }
    }
  }

  function baslat() {
    kur();
    var zaman;
    new MutationObserver(function () {
      window.clearTimeout(zaman);
      zaman = window.setTimeout(kur, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
